import TitleBar from './TitleBar.vue'

export default TitleBar
